export default __webpack_public_path__ + "static/media/weeatiphone.cc8350c1.png";